import { Image } from "@mantine/core"

interface ErrorPageProps {}

function ErrorPage(props: ErrorPageProps) {
  return (
    <div className="fc flex-col gap-3 p-10 text-center">
      <Image src="   https://cdn-icons-png.flaticon.com/512/4539/4539472.png " className="size-20" />
      <span className="max-w-xs">Ocorreu um erro ao carregar a página, tente novamente mais tarde.</span>
    </div>
  )
}

export default ErrorPage
